/**
 * A zero reminder is special: it becomes due only when no stock remains.
 * Positive reminders remain inclusive so a reminder of 2 is due at 2.
 * @param {number} quantity
 * @param {number} reminderAt
 * @returns {boolean}
 */
export function isStockReminderDue(quantity, reminderAt) {
  const stock = Number(quantity);
  const threshold = Number(reminderAt);
  if (!Number.isFinite(stock) || !Number.isFinite(threshold)) return false;
  return threshold === 0 ? stock === 0 : stock <= threshold;
}

/**
 * Use one unit from a pantry record. The record stays active while stock remains
 * and is consumed only when the final unit is used.
 * @param {number} quantity
 * @returns {{ quantity: number, consumed: boolean }}
 */
export function useOneFromStock(quantity) {
  const stock = Number(quantity);
  if (!Number.isFinite(stock) || stock <= 1) return { quantity: 0, consumed: true };
  return { quantity: Number((stock - 1).toFixed(2)), consumed: false };
}

/**
 * Adjust a numeric form value without allowing it below zero.
 * @param {number} value
 * @param {number} delta
 * @returns {number}
 */
export function adjustNonNegative(value, delta) {
  const current = Number(value);
  const change = Number(delta);
  if (!Number.isFinite(current) || !Number.isFinite(change)) return 0;
  return Math.max(0, Number((current + change).toFixed(2)));
}
